import styled from "styled-components";

export const TextHeader = styled.h3`
  margin-top: 207px;
  font-size: 50.52px;
  font-weight: 700;
  line-height: 60.6px;
  text-align: center;
  color: #101828;
  margin-bottom: 24px;

  @media (max-width: 760px) {
    font-size: 32px;
  }

  @media (max-width: 440px) {
    width: 289.43px;
    margin: 178px auto 0 auto;
    line-height: 32px;
    /* height: 64px; */
    margin-bottom: 8.11px;
  }
`

export const Text = styled.p`
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.83px;
  text-align: center;
  color: #5D5D5D;
  // marginBottom: '48px',
  width: 768px;
  margin: 0 auto 48px auto;

    @media (max-width: 760px) {
      margin-bottom: 16.21px;
      width: 259.43px;
      height: 38px;
      margin: 0 auto 16.21px auto;
    }
` 
 
export const FurtherSection = styled.div`
  background: #eefdfd;
  min-height: 514px;
  padding-top: 100px;
  /* padding-bottom: 100px; */

  @media (max-width: 600px) {
    
  }

`;
